import { observer } from 'mobx-react-lite';
import StylePanel from './StylePanel';
import type { StylePanelProps, StylePanelValueProps } from './types';

export type { StylePanelProps, StylePanelValueProps };
export default observer(StylePanel); // MANUAL OVERRIDE
